"use strict";
/**
 * Types extracted from https://discord.com/developers/docs/resources/voice
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=voice.js.map